import "./style.scss";
import { Slide, toast } from "react-toastify";
import Swal from "sweetalert2";
import { getUsers } from "../redux/features/user/_userAction";
import { getMemberSubscriptions, getSubscriptions } from "../redux/features/subscription/_subscriptionAction";
import { getMemberPlans, getPlans } from "../redux/features/plan/_planAction";
import { getNewsLetters } from "../redux/features/news-letter/_newsLetterAction";
import { getContacts } from "../redux/features/contact/_contactAction";
import { getQuickTransfers } from "../redux/features/quick-transfer/_quickTransferAction";
import { getVideos } from "../redux/features/videos/_videoAction";
import { getWelcomeEmailLogs } from "../redux/features/welcomeEmailLogs/_welcomeEmailLogsAction";
import { getWelcomeSmsLogs } from "../redux/features/welcomeSmsLogs/_welcomeSmsLogsAction";
import { getDevices } from "../redux/features/device/_deviceAction";

export const commonSwtichCases = (
    id: any,
    searchValue: any,
    dispatch: any,
    selectedAccount: any = "",
    pageSize: number = 100
) => {
    searchValue = encodeURIComponent(searchValue)
    switch (id) {
        case 'User':
            dispatch(getUsers({ 
                search: searchValue.trim(), 
                page: 1, 
                limit: 10,
                account: selectedAccount?.value || selectedAccount  // ← Add account for User
            }))
            break;
        case 'Subscription':
            dispatch(getSubscriptions({ search: searchValue.trim(), page: 1, limit: 10 }));
            break;
        case 'Plan':
            dispatch(getPlans({ search: searchValue.trim(), page: 1, limit: 10 }));
            break;
        case 'MemberSubscription':
            dispatch(getMemberSubscriptions({ search: searchValue.trim(), page: 1, limit: 10 }));
            break;
        case 'MemberPlan':
            dispatch(getMemberPlans({ search: searchValue.trim(), page: 1, limit: 10 }));
            break;
        case 'Subscribers':
            dispatch(getNewsLetters({ search: searchValue.trim(), page: 1, limit: 10 }));
            break;
        case 'Contact':
            dispatch(getContacts({ search: searchValue.trim(), page: 1, limit: 10 }));
            break;
        case 'QuickTransfer':
            dispatch(getQuickTransfers({
                search: searchValue.trim(),
                page: 1,
                limit: pageSize,
            }));
            break;
        case 'Video':
            dispatch(getVideos({
                search: searchValue.trim(),
                page: 1,
                limit: pageSize,
            }));
            break;
        case 'WelcomeEmailLogs':
            // Pass raw search — axios params will encode once (email @ must not be double-encoded)
            dispatch(getWelcomeEmailLogs({
                search: decodeURIComponent(searchValue).trim(),
                page: 1,
                limit: 10,
            }));
            break;
        case 'WelcomeSmsLogs':
            dispatch(getWelcomeSmsLogs({
                search: decodeURIComponent(searchValue).trim(),
                page: 1,
                limit: 10,
            }));
            break;
        case 'Device':
            dispatch(getDevices({ 
                search: searchValue.trim(), 
                page: 1, 
                limit: 10,
                account: selectedAccount?.value || selectedAccount  // ← Add account parameter
            }));
            break;
        default:
    }
}

export const conFirmMessage = (values) => {
    return Swal.fire(values)
}

export const commonUserStatusSwtichCases = (id: any, values: any, dispatch: any) => {
    switch (id) {
        case 'USER':
            dispatch(getUsers({ page: 1, limit: 10 }))
            break;
        default:
    }
}

export const docUrl = (images: any) => {
    const urlArray: any = [];
    for (let i = 0; i < images.length; i++) {
        urlArray.push(images[i].url);
    }
    return urlArray
}

export const toastifyOptions: any = {
    position: "top-center",
    autoClose: 1500,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
    transition: Slide,
};

export const notify = (message: any, type: any) => {
    if (type === 'error') {
        return toast.error(message, toastifyOptions);
    } else if (type === 'info') {
        return toast.info(message, toastifyOptions);
    } else if (type === 'warning') {
        return toast.warning(message, toastifyOptions);
    } else if (type === 'success') {
        return toast.success(message, toastifyOptions);
    }
};


